/**
 * NASHGO / OTO STUDENTS — Centralized Bus Routes & Departure Stations
 * Standard Departure Hubs: "الموقف الجديد بمحرم بيك" and "الكيلو 21"
 */

export const STANDARD_LAUNCH_STATIONS = [
  'الموقف الجديد بمحرم بيك',
  'الكيلو 21',
] as const;

export type StandardLaunchStation = (typeof STANDARD_LAUNCH_STATIONS)[number];

export const DEFAULT_LAUNCH_STATION: StandardLaunchStation = 'الموقف الجديد بمحرم بيك';

/**
 * Generate standard outbound routes for a given university
 * Strictly originating from "الموقف الجديد بمحرم بيك" or "الكيلو 21"
 */
export function getStandardRoutesForUniversity(universityName: string): string[] {
  const cleanUni = universityName?.trim() || 'الجامعة';
  return [
    `الموقف الجديد بمحرم بيك ◄ ${cleanUni}`,
    `الكيلو 21 ◄ ${cleanUni}`,
  ];
}

/**
 * Build route string
 */
export function buildStandardRouteName(
  station: string,
  destination: string,
  direction: 'OUTBOUND' | 'RETURN' = 'OUTBOUND'
): string {
  const cleanStation = station?.trim() || DEFAULT_LAUNCH_STATION;
  const cleanDest = destination?.trim() || 'الجامعة';
  return direction === 'RETURN'
    ? `${cleanDest} ◄ ${cleanStation}`
    : `${cleanStation} ◄ ${cleanDest}`;
}

/**
 * Extract launch station from route string or fallback to default
 */
export function extractStationFromRoute(route?: string): string {
  if (!route) return DEFAULT_LAUNCH_STATION;
  if (route.includes('21') || route.includes('الكيلو 21')) {
    return 'الكيلو 21';
  }
  if (route.includes('محرم بك') || route.includes('الموقف الجديد')) {
    return 'الموقف الجديد بمحرم بيك';
  }
  return route.split('◄')[0]?.trim() || DEFAULT_LAUNCH_STATION;
}

/**
 * Check if a station is one of the standard hubs
 */
export function isStandardLaunchStation(station?: string): boolean {
  if (!station) return false;
  return STANDARD_LAUNCH_STATIONS.some(
    (std) => station.includes(std) || std.includes(station)
  );
}
